import DataTypeModel from '../../models/DataType'
import { getUri } from './getUri'
import { env } from '../../environments/environment'
import { encodeQueryData } from './encodeQueryData'
import { RequestParams } from '../interfaces/RequestParams'
import { DataType } from '../interfaces/DataType'

/**
 * Get full url
 * @param requestParams
 * @param data
 */
const getFullUrl = (requestParams: RequestParams, data: DataType = DataTypeModel()): string =>
    `${env.REACT_APP_API_URL}${getUri(requestParams.uri, data.uriParams)}${encodeQueryData(data.bodyRequest)}`
export default getFullUrl
